<template>
	<front-admin-hub module-key="quote" />
</template>
<script>
import FrontAdminHub from '@/components/FrontAdminHub/index.vue';
export default {
	name: 'QuoteManage',
	components: { FrontAdminHub },
};
</script>
